import React, { useState } from "react";
import Switch from "@mui/material/Switch";

const App = (props) => {
  const [value, setValue] = useState(props.checked || props.value || false);

  console.log("$$$$", props.checked, props.value);

  return (
    <Switch
      checked={value}
      onChange={(event) => {
        const newValue = event.target.checked;
        props.onChange(newValue);
        setValue(newValue);
      }}
      inputProps={{ "aria-label": "Switch demo" }}
    />
  );
};

export default App;
